/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as FilterStrip } from "./FilterStrip";
export type { FilterStripProps, FilterStripOption } from "./FilterStripProps";
